import React from 'react';
import { Link } from 'react-router-dom';

/** Small Indian tricolour with a 24-spoke Ashoka Chakra. */
function IndiaFlag({ className }) {
    return (
        <svg viewBox="0 0 30 20" width="30" height="20" className={className} role="img" aria-label="Flag of India">
            <rect width="30" height="20" fill="#ffffff" />
            <rect width="30" height="6.667" fill="#FF9933" />
            <rect y="13.333" width="30" height="6.667" fill="#138808" />
            <g transform="translate(15 10)">
                <circle r="2.7" fill="none" stroke="#000080" strokeWidth="0.5" />
                <circle r="0.5" fill="#000080" />
                {Array.from({ length: 24 }).map((_, i) => (
                    <line
                        key={i}
                        x1="0" y1="0" x2="0" y2="-2.7"
                        stroke="#000080" strokeWidth="0.2"
                        transform={`rotate(${(360 / 24) * i})`}
                    />
                ))}
            </g>
        </svg>
    );
}

/** Public marketing footer. */
export default function SiteFooter() {
    return (
        <footer className="bg-grad-ink text-white/80" aria-labelledby="footer-title">
            <h2 id="footer-title" className="sr-only">Site footer</h2>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
                    <div className="max-w-sm space-y-3">
                        <div className="flex items-center gap-2">
                            <img src="/logo.png" alt="" className="h-8 w-auto rounded" />
                            <span className="font-heading font-bold text-lg text-white">TrafficWatch</span>
                            <div className="ml-3 pl-3 border-l border-white/15 flex flex-col items-center gap-1">
                                <IndiaFlag className="rounded-[2px] ring-1 ring-white/20" />
                                <span className="text-[10px] tracking-wide text-white/70 leading-none">Built in India</span>
                            </div>
                        </div>
                        <p className="text-sm leading-relaxed">
                            A citizen movement for safer, more disciplined roads. Report violations, learn road
                            safety, and help your city move better.
                        </p>
                    </div>

                    <nav className="grid grid-cols-2 gap-x-12 gap-y-2 text-sm" aria-label="Footer">
                        <a href="#how-it-works" className="hover:text-white transition-colors">How it works</a>
                        <a href="#impact" className="hover:text-white transition-colors">Impact</a>
                        <a href="#road-safety" className="hover:text-white transition-colors">Road Safety</a>
                        <Link to="/login" className="hover:text-white transition-colors">Sign in</Link>
                    </nav>
                </div>

                <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
                    <p>© {new Date().getFullYear()} TrafficWatch. Built for safer roads.</p>
                    <p className="text-center leading-relaxed">
                        Designed, Build and Maintained by
                        <br />
                        <span className="font-semibold text-white/80">Destined Software Solutions LLP, Pune</span>
                    </p>
                    <p>Evidence-based · Police-reviewed · Forwarded to authorities</p>
                </div>
            </div>
        </footer>
    );
}
